"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.application_modules_api = void 0;

var _lsfastapiClient = require("@lsoft/lsfastapi-client");

var openapi = {
  openapi: "3.0.2",
  info: {
    title: "application-modules-api",
    version: "1.0.0"
  },
  paths: {
    "/{app_name}/modules": {
      get: {
        tags: ["application_modules"],
        summary: "Modules Get",
        operationId: "app_name__modules_get",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ModulesModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["application_modules"],
        summary: "Modules Put",
        operationId: "app_name__modules_put",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ModulesModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      HTTPValidationError: {
        title: "HTTPValidationError",
        type: "object",
        properties: {
          detail: {
            title: "Detail",
            type: "array",
            items: {
              $ref: "#/components/schemas/ValidationError"
            }
          }
        }
      },
      ModulesModel: {
        title: "ModulesModel",
        required: ["APPLICATION_MODULES"],
        type: "object",
        properties: {
          APPLICATION_MODULES: {
            title: "Application Modules",
            type: "array",
            items: {
              type: "string"
            }
          }
        }
      },
      ValidationError: {
        title: "ValidationError",
        required: ["loc", "msg", "type"],
        type: "object",
        properties: {
          loc: {
            title: "Location",
            type: "array",
            items: {
              type: "string"
            }
          },
          msg: {
            title: "Message",
            type: "string"
          },
          type: {
            title: "Error Type",
            type: "string"
          }
        }
      }
    }
  }
};
var application_modules_api = (0, _lsfastapiClient.Api)(openapi);
exports.application_modules_api = application_modules_api;
//# sourceMappingURL=index.js.map